// Scroll progress ([data-scroll-progress]): while an element crosses the window, --progress runs from 0 (its top at
// the window's bottom edge) to 1 (its bottom at the top edge); the CSS turns it into parallax and running type.
// Only elements on screen are measured, once per frame, and each gets a "scrollprogress" event (detail: the value)
// for scripts that follow it. With reduced motion --progress stays at 0.5, the resting state every effect is
// designed around.
import { reducedMotion } from './motion.js'

export function initScrollProgress() {
	const elements = document.querySelectorAll('[data-scroll-progress]')
	if (!elements.length) return

	const visible = new Set()
	let frame = 0

	const update = () => {
		frame = 0
		const height = window.innerHeight
		visible.forEach((element) => {
			const box = element.getBoundingClientRect()
			const progress = reducedMotion.matches ? 0.5 : Math.min(1, Math.max(0, (height - box.top) / (height + box.height)))
			element.style.setProperty('--progress', progress.toFixed(4))
			element.dispatchEvent(new CustomEvent('scrollprogress', { detail: progress }))
		})
	}
	const schedule = () => {
		if (!frame) frame = requestAnimationFrame(update)
	}

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => (entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target)))
		schedule()
	})
	elements.forEach((element) => observer.observe(element))

	window.addEventListener('scroll', schedule, { passive: true })
	window.addEventListener('resize', schedule)
	reducedMotion.addEventListener('change', schedule)
}
